<h2 class="page-title">Implementation Info</h2>

<div class="card-section">
  <h5 class="mb-3">Status</h5>
  <p class="mb-1">Complete: <strong>{{ this.data.supplier_implementation.is_complete }}</strong></p>
  <p class="mb-2">Direct Hit complete: <strong>{{ this.data.supplier_implementation.is_complete || this.data.supplier_implementation.is_ready_for_direct_hit_extraction }}</strong></p>
  @if (this.data.supplier_implementation.missing.length > 0) {
    <p class="mb-1 text-muted small">Missing fields:</p>
    <ul class="mb-0">
      @for (item of this.data.supplier_implementation.missing; track item) {
        <li>{{ item }}</li>
      }
    </ul>
  }
</div>

<div class="card-section">
  <h5 class="mb-2">Raw JSON</h5>
  <pre class="impl-json" [innerHTML]="this.data.supplier_implementation | jsonHighlight"></pre>
</div>
